// lib/auth/logoutTracker.ts

export const logoutTracker = {
  isManual: false,
  setManualLogout(status: boolean) {
    this.isManual = status;
  },
};
